import { axiosInstance } from "../config";

export default {
  state: {
    categories_property_count: [],
  },
  mutations: {
    Set_categories_property_count(state, payload) {
      state.categories_property_count = payload;
    },
  },
  actions: {
    async LoadAllCategoriesCRM({ commit }) {
      return await axiosInstance
        .get("/category/property_count")
        .then(function (data) {
          commit("Set_categories_property_count", data?.data?.data);
          return data?.data?.data;
        })
        .catch(function (error) {
          return {
            error: error.response.data.message,
          };
        });
    },
    async CreateCategory(commit, payload) {
      const formData = new FormData();
      for (const key in payload) {
        if (
          Object.prototype.hasOwnProperty.call(payload, key) &&
          payload[key] !== undefined
        ) {
          formData.append(key, payload[key]);
        }
      }
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      return await axiosInstance
        .post("/category", formData, config)
        .then(function (data) {
          return data?.data;
        })
        .catch(function (error) {
          return {
            error: error.response.data.message,
          };
        });
    },
    async UpdateCategory(commit, payload) {
      const formData = new FormData();
      formData.append("_method", "PUT");
      for (const key in payload.data) {
        if (
          Object.prototype.hasOwnProperty.call(payload.data, key) &&
          payload.data[key] !== undefined
        ) {
          formData.append(key, payload.data[key]);
        }
      }
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      return await axiosInstance
        .post("/category/" + payload.ID, formData, config)
        .then(function (data) {
          return data?.data;
        })
        .catch(function (error) {
          return {
            error: error.response.data.message,
          };
        });
    },
    async category_delete_by_id(commit, payload) {
      return await axiosInstance
        .delete("/category/" + payload)
        .then(function (data) {
          return data?.data;
        })
        .catch(function (error) {
          return {
            error: error.response.data.message,
          };
        });
    },
  },
  getters: {
    getCategoriesCRM: (state) => state.categories_property_count,
  },
};
